<div class="section">
  <div class="container">
    <div class="row row--justify-center">
      <div class="message">
        <div class="row">
          <div class="col message__text">
            <h2 class="panel__title">Product not valid for your country selection.</h2>
            <p>
              For further information, please reach out to our client engagement team
              <a [href]="(urlBundle$ | async)?.newTicket" target="_blank">here</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
